import { z } from "zod";
export const heartbeatDecisionSchema = z.object({
    action: z.enum(["notify", "defer", "escalate"]),
    reason: z.string(),
    needsEscalation: z.boolean().default(false),
    notificationTitle: z.string().nullable().default(null),
    notificationBody: z.string().nullable().default(null),
    deepLink: z.string().nullable().default(null),
});
export function assignHeartbeatCohort(userId, controlPercent = 10) {
    const h = fnv1a(userId);
    return h % 100 < controlPercent ? "control" : "treatment";
}
function fnv1a(s) {
    let h = 0x811c9dc5;
    for (let i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 0x01000193) >>> 0;
    }
    return h;
}
//# sourceMappingURL=heartbeat.js.map